import { render } from "./cliente-editar.vue?vue&type=template&id=5b22743e"
import script from "./cliente-editar.vue?vue&type=script&lang=js"
export * from "./cliente-editar.vue?vue&type=script&lang=js"

import "./cliente-editar.vue?vue&type=style&index=0&id=5b22743e&lang=css"

import exportComponent from "C:\\Users\\iuril\\Documents\\econopro\\mainapp\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__